<template>
  <div class="w-full flex">
    <div class="mr-3">
      <vs-avatar
        :src="src"
        :icon="icon"
        icon-pack="feather"
        :text="text"
        :size="size"
        :color="color"
      ></vs-avatar>
    </div>
    <div class="flex flex-col">
      <div class="font-semibold">{{ name }}</div>
      <div class="text-sm">{{ subname }}</div>
      <div>
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    src: {
      type: String,
      default: null
    },
    text: {
      type: String,
      default: ""
    },
    size: {
      type: String,
      default: "normal"
    },
    color: {
      type: String,
      default: "grey"
    },
    icon: {
      type: String,
      default: "icon-user"
    },
    name: {
      type: String,
      default: ""
    },
    subname: {
      type: String,
      default: ""
    }
  }
};
</script>
